import { useQuery } from '@tanstack/react-query';
import { CHAT_API } from 'utils/globalApiServices';
import { AI_CHAT } from './queryKeys';

const queryFn = async ({ conversationId }) => {
  const data = await CHAT_API.get(`conversations/${conversationId}`);
  return data?.data?.records ?? [];
}

const useGetConversationQuery = ({ conversationId, setConversation }) => {
    return useQuery({
    staleTime: 0,
    cacheTime: 0,
    queryFn: () => queryFn({ conversationId }),
    queryKey: [AI_CHAT.CONVERSATION, conversationId],
    enabled: !!conversationId,
    onSuccess: (response) => {
      setConversation(response.reverse() ?? []);
    },
  });
};

export default useGetConversationQuery
